var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotificationImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.889,
    height: 22.667,
    viewBox: "0 0 18.889 22.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.3,15.973a6.326,6.326,0,0,1-2.247-4.84V8.5a6.616,6.616,0,0,0-5.667-6.536V.944a.944.944,0,1,0-1.889,0v1.02A6.616,6.616,0,0,0,4.833,8.5v2.633a6.333,6.333,0,0,1-2.255,4.848,1.652,1.652,0,0,0,1.075,2.908H19.236A1.653,1.653,0,0,0,20.3,15.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.8,23.833A3.547,3.547,0,0,0,15.266,21H8.326A3.547,3.547,0,0,0,11.8,23.833Z",
    transform: "translate(-0.351 -1.167)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notificationImg.3dce968e.svg";
export { ForwardRef as ReactComponent };